import React from 'react';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import CopyButton from '../../common/controls/CopyButton';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { removeZeroDecimals } from '../../../utils/removeZeroDecimals';
import { checkExpiryDate } from '../../../utils/checkExpiryDate';
import { numberToCurrencyFormat } from '../../../utils/numberToCurrencyFormat';

export default function InventoryItemView({setItem, handleEdit, handleCreateTransaction, open, onClose, item = null}) { 

    const handleClose = () => {
        onClose();
    };

    const handleEditClick = () => {
        handleEdit(item);
    };

    const handleCreateTransactionClick = () => {
        handleCreateTransaction(item);
    };

    if (!item) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            
            <DialogTitle>Inventory Item</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Item Name</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{item.name}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Category</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{item.category.name}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>SKU</Typography>
                <Box display="inline-flex" alignItems="center">
                    <Typography variant="body1" sx={{ mt: 0 }}>{item.sku || "(none)"}</Typography>
                    { item.sku ? <CopyButton text={item.sku} /> : null }
                </Box>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Supplier</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{item.supplier?.name || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Auto Notify Supplier On Low Stock</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{item.auto_notify_supplier ? 'Yes' : 'No'}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Unit of Measure (UoM)</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{item.uom}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Cost per UoM</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{numberToCurrencyFormat(item.cost_price)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Selling Price per UoM</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{numberToCurrencyFormat(item.selling_price)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Current Stock</Typography>
                <Typography variant="body1" sx={{ mt: 0 }} color={Number(item.current_stock) <= Number(item.low_stock) ? "error" : "text.primary" }>{`${removeZeroDecimals(item.current_stock)}${item.uom}`}</Typography>
                { item.supplier_notified ? 
                <>
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Supplier Notified On</Typography>
                <Typography variant="body1" sx={{ mt: 0 }} color={Number(item.current_stock) <= Number(item.low_stock) ? "error" : "text.primary" }>{`${formatToLocalDateTime(item.notification_date)}`}</Typography>
                </>
                : null }
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Low Stock Amount</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{`${removeZeroDecimals(item.low_stock)}${item.uom}`}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Expiry Date</Typography>
                <Typography variant="body1" sx={{ mt: 0 }} color={checkExpiryDate(item.expiry_date) ? "error" : "text.primary" }>{item.expiry_date || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Status</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{item.status}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Created</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(item.createdAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Last Updated</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(item.updatedAt)}</Typography>

            </DialogContent>
            <DialogActions>
                {handleEdit ? 
                <Button onClick={handleEditClick}>
                    <EditIcon />
                </Button>
                : null }
                {handleCreateTransaction ? 
                <Button onClick={handleCreateTransactionClick}>
                    <CompareArrowsIcon />
                </Button>
                : null }
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}